@if (activeBehavior) {
  <div>
    <i [ngClass]="activeBehavior.icon" class="mr-2 text-600"></i
    >{{
      'ADMIN.APPOINTMENT.APPOINTMENT_BEHAVIOUR_TYPE.' + activeBehavior.name
        | translate
    }}
  </div>
} @else {
  -
}
